module.exports = __webpack_public_path__ + "fonts/IdeaBuddyFont.25c796ab.woff2";